const formatPercent = (selected_value, current_value) => {
  const value_diff = Number((selected_value * 100) / current_value).toFixed(1);

  const percent_diff = value_diff > 0 ? value_diff : -value_diff;
  return percent_diff;
};

export default formatPercent;
